module.exports = __webpack_public_path__ + "static/img/articlepro.d0fdb3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articlepro.jpg
// module id = Gw9g
// module chunks = 1